import { AssetListResponse } from "./models/assetListResponse";

export class VinResponse {
    
   public assetList :AssetListResponse[] = [];
   public contractNumber: string;
   public scheduleNumber: string; 
   public contractType: string; 
   public onlinePayFlag: string;  
}